export const MAINTENANCE_INTERVAL_MODAL_EVENT = 'company:settings:maintenance-interval:modal';
export const MAINTENANCE_INTERVAL_MODAL_OPEN = `${MAINTENANCE_INTERVAL_MODAL_EVENT}:open`;
export const MAINTENANCE_INTERVAL_MODAL_CLOSE = `${MAINTENANCE_INTERVAL_MODAL_EVENT}:close`;
